import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { apiConstant } from '../app.constant';
import { environment } from 'src/environments/environment';
import { EmailTemplate, EmailBranding } from '../app.model';

@Injectable({
  providedIn: 'root'
})
export class EmailTemplateService {

  private baseUrl = `${environment.baseUrl}`;

  constructor(private http: HttpClient) { }

  getTemplates() {
    return this.http.get<{ data: EmailTemplate[] }>(this.baseUrl + apiConstant.EMAIL_TEMPLATES);
  }

  updateTemplate(uuid: string, payload: Partial<EmailTemplate>) {
    return this.http.put<{ data: EmailTemplate }>(this.baseUrl + apiConstant.EMAIL_TEMPLATES + '/' + uuid, payload);
  }

  previewTemplate(uuid: string, payload: Partial<EmailTemplate> = {}) {
    return this.http.post<any>(this.baseUrl + apiConstant.EMAIL_TEMPLATES + '/' + uuid + '/preview', payload);
  }

  resetTemplate(uuid: string) {
    return this.http.post<{ data: EmailTemplate }>(this.baseUrl + apiConstant.EMAIL_TEMPLATES + '/' + uuid + '/reset', {});
  }

  getBranding() {
    return this.http.get<EmailBranding>(this.baseUrl + apiConstant.EMAIL_BRANDING);
  }

  setBranding(payload: EmailBranding) {
    return this.http.post<any>(this.baseUrl + apiConstant.SET_EMAIL_BRANDING, payload);
  }
}
